import { Box } from 'dash-ui';
import ManagementTabs from './components/ManagementTabs/ManagementTabs';

const ManagementPage = () => (
  <Box w="100%">
    <ManagementTabs />
  </Box>
);

export default ManagementPage;
